import { render } from "./CodeBlock.vue?vue&type=template&id=73d0691a&scoped=true&bindings={\"color1\":\"props\",\"color2\":\"props\",\"flip\":\"props\",\"horizontal\":\"props\",\"startX\":\"data\",\"endX\":\"data\",\"startY\":\"data\",\"endY\":\"data\",\"style\":\"options\",\"clickPre\":\"options\",\"checkSettings\":\"options\"}"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"

import "./CodeBlock.vue?vue&type=style&index=0&id=73d0691a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73d0691a"

export default script